export default __webpack_public_path__ + "static/media/datascience.6df0a77b.jpg";